const areas = {
  tokyo: "東京都",
  kanagawa: "神奈川県",
};

export default function Area() {
  return (
    <section id="area" role="region" aria-label="対応エリア" className="relative bg-background-50 py-20 md:py-32 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-accent-500"></span>
            <span className="text-xs tracking-[0.3em] uppercase text-accent-700 font-medium">
              Service Area
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
            東京・神奈川、<br />
            <span className="text-accent-600">地域に根ざして</span>。
          </h2>
          <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-10">
            東京都・神奈川県を中心に、幅広く対応しています。
            掲載のないエリアもお気軽にご相談ください。
          </p>

          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-map-pin-2-line text-accent-700"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{areas.tokyo}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-map-pin-2-line text-accent-700"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{areas.kanagawa}</span>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-background-200/70">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12972.84!2d139.6493!3d35.6663!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDM5JzU4LjciTiAxMznCsDM4JzU3LjUiRQ!5e0!3m2!1sja!2sjp!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="株式会社Wind 所在地"
            ></iframe>
          </div>
          <div className="absolute -bottom-5 left-5 right-5 md:left-10 md:right-10 bg-foreground-950 text-background-50 rounded-xl p-5 md:p-6 flex items-center justify-between gap-4">
            <div>
              <p className="text-[10px] tracking-[0.3em] uppercase text-background-50/60 mb-1">
                Head Office
              </p>
              <p className="text-sm md:text-base font-heading font-bold">
                〒156-0043 東京都世田谷区松原3-30-10 双葉屋ビル 2F
              </p>
            </div>
            <span className="hidden sm:flex w-10 h-10 rounded-full bg-primary-500 items-center justify-center shrink-0">
              <i className="ri-map-pin-fill text-background-50"></i>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}